// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".legal-databases-wrapper{width:1280px;margin:0 auto;padding:0 36px 36px;box-sizing:border-box}.legal-databases-wrapper .legal-databases-table thead{position:sticky;top:106px;z-index:20}.legal-databases-wrapper .legal-databases-table tbody td{line-height:22px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
